var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Upload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6f6f6f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-upload",
    className: "cls-1",
    d: "M13.987,6a.889.889,0,0,0-.615.26L10.7,8.927a.889.889,0,1,0,1.257,1.257l1.149-1.149v8.076a.889.889,0,1,0,1.778,0V9.035l1.149,1.149A.889.889,0,1,0,17.3,8.927L14.628,6.26A.889.889,0,0,0,13.987,6Zm-5.32,4.889A2.68,2.68,0,0,0,6,13.555v5.778A2.68,2.68,0,0,0,8.667,22H19.333A2.68,2.68,0,0,0,22,19.333V13.555a2.68,2.68,0,0,0-2.667-2.667h-.444a.889.889,0,1,0,0,1.778h.444a.876.876,0,0,1,.889.889v5.778a.876.876,0,0,1-.889.889H8.667a.876.876,0,0,1-.889-.889V13.555a.876.876,0,0,1,.889-.889h.444a.889.889,0,1,0,0-1.778Z",
    transform: "translate(-6 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Upload);
export default __webpack_public_path__ + "static/media/icons8-upload.db5875737acb164b5eb560839ed7a243.svg";
export { ForwardRef as ReactComponent };